import { css } from 'styled-components';
import {
  grid, gridUnit, rgba, BreakpointQueryName, FontWeight, ThemedFunctor,
} from '@doveit/lego';

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme)}
  align-items: center;
  padding: .75rem ${theme.spaceUnits.mobile.SMALL} 2rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${theme.zIndex.inpage};
  background-color: ${rgba(theme.palettes.neutrals.lightest, 0.9)};
  box-shadow: 0 -2px 10px rgba(0,0,0,0.2);

  button {
    background-color: ${theme.palettes.neutrals.lightest};
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: none;
  }
`;

export const text: ThemedFunctor = ({
  theme,
}) => css`
  ${gridUnit(theme, { size: 1 })}
  text-align: center;
  font-weight: ${FontWeight.NORMAL};
  padding: ${theme.spaceUnits.mobile.SMALLEST};
`;

export const buttonBox: ThemedFunctor = ({
  theme,
}) => css`
  ${gridUnit(theme, { size: 1 / 2 })}
  padding: ${theme.spaceUnits.mobile.SMALLEST}
`;
